import { TableRow as MuiTableRow } from '@mui/material';

const TableRow = ({ ...elementProps }) => (
  <MuiTableRow data-testid="tableRow" {...elementProps}>
    {elementProps.children}
  </MuiTableRow>
);

export default TableRow;
